import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import axios, { AxiosResponse } from 'axios';
import { Action } from 'redux-saga';
import { automaticApi } from '@/settings/api';
import { setCustomer } from '@/redux/ducks/customer';

export interface Fetch {
    callback?: (success: boolean) => void;
}

export interface GetCustomerDataAction {
    type: string;
    payload: Fetch;
}

const uri = '/customer/v1/account';

export default function* getCustomerData({
  payload,
}: GetCustomerDataAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
  try {
    const response = yield call(
      automaticApi.get,
      uri
    );

    const data = response?.data;

    if (data?.errorMessage || data?.serviceMessage?.codigoRetorno !== 0) {
      throw new axios.Cancel('Erro ao procurar por dados do cliente');
    }

    yield put(setCustomer({
      client: {
        ...data?.client,
        registrationDate: data?.client?.registrationDate?.split('T')[0],
      },
      account: {
        ...data?.account,
        blockedType: data?.account?.blockedType ?? '',
      }
    }));
    if (payload?.callback) yield call(payload.callback, true);
  } catch (err) {
    if (payload?.callback) yield call(payload.callback, false);
  }
}
